import { BaseQueryParams } from '../common/models/base-query-params';
import { buildBasicPaginatedSearchParams } from '../common/utils/url-search-params.helper';
import { apiPaths } from '../config/apiPaths';
import { MetaCategory } from '../modules/Restaurants/types';
import axiosInstance from './axios';

export const getMetaCategories = ({ q, page, limit }: BaseQueryParams): Promise<MetaCategory[]> => {
  const urlParams = buildBasicPaginatedSearchParams(page, limit, q);

  return axiosInstance
    .get<{ items: MetaCategory[] }>(apiPaths.META_CATEGORIES, { params: urlParams })
    .then(({ data }) => data.items);
};
